import { MaterialCaptchaRow } from './material-captcha-row';

export class MaterialCaptcha {
    /** Optional for erb call */
    public status: number;
    /** Only for captcha service v1 compatibility */
    public next: string;
    public signature: string;
    public hash: string;
    public rows: MaterialCaptchaRow[];
    public indications: string[];

    public constructor(args: any) {
        this.status = args.status;
        this.next = args.next;
        this.signature = args.signature;
        this.hash = args.hash;
        this.rows = args.rows.map((rows: MaterialCaptchaRow[]) => {
            return rows.map((row: MaterialCaptchaRow) => {
                return new MaterialCaptchaRow(row);
            });
        });
        this.indications = args.indications;
    }
}
